"use strict";

var _slicedToArray = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mover = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

var Mover =
/*#__PURE__*/
function () {
  function Mover(container, particle) {
    _classCallCheck(this, Mover);

    this.container = container;
    this.particle = particle;
  }

  _createClass(Mover, [{
    key: "move",
    value: function move(delta) {
      var particle = this.particle;
      particle.bubble.inRange = false;
      particle.links = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.container.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (particle.destroyed) {
            break;
          }

          if (plugin.particleUpdate) {
            plugin.particleUpdate(particle, delta);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (particle.destroyed) {
        return;
      }

      this.moveParticle(delta);
      this.moveParallax();
    }
  }, {
    key: "moveParticle",
    value: function moveParticle(delta) {
      var _a;

      var particle = this.particle;
      var particlesOptions = particle.particlesOptions;

      if (!particlesOptions.move.enable) {
        return;
      }

      var container = this.container;
      var slowFactor = this.getProximitySpeedFactor();
      var baseSpeed = (_a = particle.moveSpeed) !== null && _a !== void 0 ? _a : container.retina.moveSpeed;
      var moveSpeed = baseSpeed / 2 * slowFactor * delta.factor;
      this.applyNoise(delta);
      particle.position.x += particle.velocity.horizontal * moveSpeed;
      particle.position.y += particle.velocity.vertical * moveSpeed;

      if (particlesOptions.move.vibrate) {
        particle.position.x += Math.sin(particle.position.x * Math.cos(particle.position.y));
        particle.position.y += Math.cos(particle.position.y * Math.sin(particle.position.x));
      }
    }
  }, {
    key: "applyNoise",
    value: function applyNoise(delta) {
      var particle = this.particle;
      var particlesOptions = particle.particlesOptions;
      var noiseOptions = particlesOptions.move.noise;
      var noiseEnabled = noiseOptions.enable;

      if (!noiseEnabled) {
        return;
      }

      var container = this.container;

      if (particle.lastNoiseTime <= particle.noiseDelay) {
        particle.lastNoiseTime += delta.value;
        return;
      }

      var noise = container.noise.generate(particle);
      particle.velocity.horizontal += Math.cos(noise.angle) * noise.length;
      particle.velocity.horizontal = Utils_1.Utils.clamp(particle.velocity.horizontal, -1, 1);
      particle.velocity.vertical += Math.sin(noise.angle) * noise.length;
      particle.velocity.vertical = Utils_1.Utils.clamp(particle.velocity.vertical, -1, 1);
      particle.lastNoiseTime -= particle.noiseDelay;
    }
  }, {
    key: "moveParallax",
    value: function moveParallax() {
      var container = this.container;
      var options = container.options;

      if (!options.interactivity.events.onHover.parallax.enable) {
        return;
      }

      var particle = this.particle;
      var parallaxForce = options.interactivity.events.onHover.parallax.force;
      var mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var windowDimension = {
        height: window.innerHeight / 2,
        width: window.innerWidth / 2
      };
      var parallaxSmooth = options.interactivity.events.onHover.parallax.smooth;
      var tmp = {
        x: (mousePos.x - windowDimension.width) * (particle.size.value / parallaxForce),
        y: (mousePos.y - windowDimension.height) * (particle.size.value / parallaxForce)
      };
      particle.offset.x += (tmp.x - particle.offset.x) / parallaxSmooth;
      particle.offset.y += (tmp.y - particle.offset.y) / parallaxSmooth;
    }
  }, {
    key: "getProximitySpeedFactor",
    value: function getProximitySpeedFactor() {
      var container = this.container;
      var options = container.options;
      var active = Utils_1.Utils.isInArray(Enums_1.HoverMode.slow, options.interactivity.events.onHover.mode);

      if (!active) {
        return 1;
      }

      var mousePos = this.container.interactivity.mouse.position;

      if (!mousePos) {
        return 1;
      }

      var particlePos = this.particle.getPosition();
      var dist = Utils_1.Utils.getDistance(mousePos, particlePos);
      var radius = container.retina.slowModeRadius;

      if (dist > radius) {
        return 1;
      }

      var proximityFactor = dist / radius || 0;
      var slowFactor = options.interactivity.modes.slow.factor;
      return proximityFactor / slowFactor;
    }
  }]);

  return Mover;
}();

exports.Mover = Mover;